import script from "./TaskControls.vue?vue&type=script&lang=ts&setup=true"
export * from "./TaskControls.vue?vue&type=script&lang=ts&setup=true"

import "./TaskControls.vue?vue&type=style&index=0&id=1de57a3e&lang=less"

const __exports__ = script;

export default __exports__